import { useState } from 'react';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type { IEditAddressFormValues, IEditAddressModel, IEditAddressSubmitResult } from '@/types/history/edit-address';

const EDIT_ADDRESS_ENDPOINT = '/api/register/edit-address';

const defaultEditAddressModel: IEditAddressModel = {
    id: 0,
    editKey: '',
    isIE: false,

    addressLine1: '',
    city: '',
    state: null,
    postalCode: '',

    stateOptions: [],

    languageData: {},
};

type TEditAddressResult = IEditAddressSubmitResult & { results?: Partial<IEditAddressModel> };

export const useEditAddress = (registrationId: number, editKey: string) => {
    const url = `${EDIT_ADDRESS_ENDPOINT}/${registrationId}/${editKey}`;

    const { model: loaded, isLoading, error } = useApiModel(url, defaultEditAddressModel);
    const [override, setOverride] = useState<IEditAddressModel | null>(null);
    const model = override ?? loaded;

    const { submit: post, isSubmitting, submitError } = useApiSubmit<IEditAddressFormValues, Partial<IEditAddressModel>, TEditAddressResult>(
        url,
        (values) => ({
            addressLine1: values.addressLine1,
            city: values.city,
            state: values.state ? parseInt(values.state) : null,
            postalCode: values.postalCode,
        }),
        (results) => ({ results }),
    );

    const submit = (values: IEditAddressFormValues): Promise<IEditAddressSubmitResult> =>
        post(values).then(({ results, ...result }) => {
            if (results) setOverride({ ...defaultEditAddressModel, ...results });

            return result;
        });

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
